/* istanbul ignore file */
import properties from 'properties';
import AppUtil from 'js/utils/AppUtil';
import AppHelper from 'js/app/AppHelper';
import { APP_URL_CONSTANTS } from '../../../common/constants/GlobalConstants';
import { closeCardTypeSettings } from 'js/app/actions/AppActions';

export const populateCardTypeListingData = data => {
    AppHelper.setAppData( 'card_type_list', data);
}

export const getCardTypeListing = cardTypeList => {
    return () => {
        if ( !cardTypeList ) {
            const url = properties.isIntegrated ? properties.url + APP_URL_CONSTANTS.GET_CARD_TYPE_SETTINGS + "/" + AppHelper.getParamData('icentid') + "/" + 
            AppHelper.getAppData('projectId') + "/" + AppHelper.getParamData('sologinid') : "data/cardTypeList.json";

            AppUtil.ajax(url, undefined, response => {
                populateCardTypeListingData( response );
            });
        }
    }
}

export const saveCardTypeSettings = data => {
    return dispatch => {
        const url = properties.url + APP_URL_CONSTANTS.SAVE_CARD_TYPE_SETTINGS + "/" + AppHelper.getAppData('user_data').id +
        "/" + AppHelper.getParamData('sologinid');

        AppUtil.ajax(url, {data}, () => {
            dispatch( getCardTypeListing() );
            dispatch(closeCardTypeSettings());
        }, undefined, undefined, undefined, false);
    }
    
}
